// extracted by mini-css-extract-plugin
export var compactFilters = "_cm-4";
export var detailImage = "_cm-1";
export var dropdownContainer = "_cm-2";
export var imageContainer = "_cm-0";
export var selectedCard = "_cm-3";